import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

export const SEARCH_META_DEFAULT: ISearchMeta = {
  count: 0,
  fullUrl: '',
  queryString: '',
  h1: '',
};
